import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Modal, Table } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddSommeMin from "./AddSommeMin";
import ActionDropdown from "../../production/components/ActionDropdown";

const SommeMinList = () => {
  const [sommeMins, setSommeMins] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedSommeMin, setSelectedSommeMin] = useState(null);

  const fetchData = () => {
    axios
      .get(`${API_URL}/api/parametre/type/SOMME_MIN`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      })
      .then((res) => {
        const sorted = res.data.sort((a, b) =>
          b.libelleParametre.localeCompare(a.libelleParametre)
        );
        setSommeMins(sorted);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors du chargement.");
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleShow = (edit = false, item = null) => {
    setEditMode(edit);
    setSelectedSommeMin(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedSommeMin(null);
    fetchData();
  };

  const onAdd = (newItem) => {
    setSommeMins((prev) => [newItem, ...prev]);
  };

  const onUpdate = (updatedItem) => {
    setSommeMins((prev) =>
      prev.map((item) =>
        item.parametreId === updatedItem.parametreId ? updatedItem : item
      )
    );
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Confirmer la suppression",
      content: "Cette action est irréversible.",
      okText: "Oui",
      cancelText: "Non",
      okType: "danger",
      onOk: () => {
        axios
          .delete(`${API_URL}/api/parametre/${id}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
          .then(() => {
            setSommeMins((prev) => prev.filter((item) => item.parametreId !== id));
            toast.success("Supprimé avec succès.");
          })
          .catch((err) => {
            console.error(err);
            toast.error("Erreur lors de la suppression.");
          });
      },
    });
  };

  const columns = [
    {
      title: "Libellé",
      dataIndex: "libelleParametre",
      key: "libelleParametre",
    },
    {
      title: "Montant",
      dataIndex: "valeur",
      key: "valeur",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
       <ActionDropdown
  actions={[
    {
      key: 'edit',
      label: 'Modifier',
      icon: <EditOutlined />,
      onClick: () => handleShow(true, record),
    },
    {
      key: 'delete',
      label: 'Supprimer',
      icon: <DeleteOutlined />,
      danger: true,
      onClick: () => handleDelete(record.parametreId),
    },
  ]}
/>

      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="PARAMETRES_SINISTRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => handleShow(false)}
                style={{ marginBottom: 16 }}
              >
                Ajouter une nouvelle somme minimale
              </Button>

              <Table
                dataSource={sommeMins}
                columns={columns}
                rowKey="parametreId"
                pagination={{ pageSize: 10 }}
              />
            </div>
            <Footer />
          </div>
        </div>
      </div>

      {showModal && (
        <AddSommeMin
          show={showModal}
          handleClose={handleClose}
          editMode={editMode}
          selectedSommeMin={selectedSommeMin}
          sommeMins={sommeMins}
          onAdd={onAdd}
          onUpdate={onUpdate}
        />
      )}
    </div>
  );
};

export default SommeMinList;
